import React from 'react';
import { Heading } from '@chargify/custom-ui-components';
import { Icon } from '@chargify/icons';
import { Wrapper } from './ExpiredStatus.styles';
type Props = {
  text: string;
};
export const ExpiredStatus = ({ text }: Props) => (
  <Wrapper>
    <Icon fill={'danger.main'} type={'circleCross'} size={16} />
    <Heading variant={'h5'} color={'danger.main'}>
      {text}
    </Heading>
  </Wrapper>
);
